import styled from 'styled-components';

export const SubHeaderStyled = styled.div<{ mt?: string }>`
  margin-top: ${(p) => p.mt || '40px'};
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
